/* WonderCuts: filter downstream variant choices by actual Shopify combinations. */
(function () {
  'use strict';
  const selector = 'variant-radios[data-section], variant-selects[data-section]';
  function refresh(picker) {
    const script = picker.querySelector('script[type="application/json"]');
    if (!script) return;
    let variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;
    const practiceReady = picker.dataset.wcPracticeReady === 'true';
    const pngReady = picker.dataset.wcPngReady === 'true';
    const svgReady = picker.dataset.wcSvgReady === 'true';
    // Product Type is option 1 in the WonderCuts listing setup.
    // These metafields gate only new product types; existing cutter options stay intact.
    const permitted = variants.filter(v => {
      const kind = String(v.options[0] || '').toLowerCase();
      if (kind.includes('practice cookie') && !practiceReady) return false;
      if (kind.includes('png') && !pngReady) return false;
      if (kind.includes('svg') && !svgReady) return false;
      return true;
    });
    const groups = Array.from(picker.querySelectorAll('fieldset.product-form__input, .product-form__input--dropdown'));
    if (!groups.length) return;
    const selection = groups.map(group => {
      const select = group.querySelector('select');
      return select ? select.value : (group.querySelector('input[type="radio"]:checked') || {}).value;
    });
    for (let i = 0; i < groups.length; i++) {
      const group = groups[i];
      const allowed = new Set(permitted.filter(v => {
        for (let j = 0; j < i; j++) if (v.options[j] !== selection[j]) return false;
        return true;
      }).map(v => v.options[i]));
      const select = group.querySelector('select');
      let firstAllowed = null;
      if (select) {
        for (const option of select.options) {
          const valid = allowed.has(option.value);
          option.hidden = !valid;
          option.disabled = !valid;
          if (valid && firstAllowed === null) firstAllowed = option.value;
        }
        if (!allowed.has(select.value) && firstAllowed !== null) {
          select.value = firstAllowed;
          selection[i] = firstAllowed;
          queueMicrotask(() => select.dispatchEvent(new Event('change', { bubbles: true })));
        } else selection[i] = select.value;
      } else {
        const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
        for (const radio of radios) {
          const valid = allowed.has(radio.value);
          radio.disabled = !valid;
          radio.hidden = !valid;
          const label = group.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
          if (label) { label.hidden = !valid; label.style.display = valid ? '' : 'none'; }
          if (valid && firstAllowed === null) firstAllowed = radio.value;
        }
        const selected = radios.find(r => r.checked);
        if ((!selected || !allowed.has(selected.value)) && firstAllowed !== null) {
          const replacement = radios.find(r => r.value === firstAllowed);
          replacement.checked = true;
          selection[i] = firstAllowed;
          queueMicrotask(() => replacement.dispatchEvent(new Event('change', { bubbles: true })));
        } else selection[i] = selected ? selected.value : null;
      }
    }
  }
  function init() { document.querySelectorAll(selector).forEach(refresh); }
  document.addEventListener('change', function (event) {
    const picker = event.target.closest(selector);
    if (picker) queueMicrotask(() => refresh(picker));
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
